import { HANDLE_API_CALL_EXCEPTION } from "./actionTypes";

export const handleApiCallException = (error) => {
  return {
    type: HANDLE_API_CALL_EXCEPTION,
    payload: { error },
  };
};
